<button
  sbSidebarFooter
  type="button"
  [sbMenuTriggerFor]="profileMenu.panel"
  [sbMenuTriggerPlacement]="'top-start'"
  [attr.aria-label]="'Profile menu' | translate"
>
  <div sb-sidebar-footer-icon class="relative flex size-full items-center justify-center">
    <sb-avatar
      [url]="user()?.avatar_30x30"
      [firstName]="user()?.first_name"
      [lastName]="user()?.last_name"
      [size]="'base'"
      [colorSeed]="user()?.id"
    />
    @if (notificationCount() > 0) {
      <sb-notification-badge
        class="absolute top-0 right-1.5 translate-x-1/2 -translate-y-1/2"
        [count]="notificationCount()"
      />
    }
  </div>
  <span sb-sidebar-footer-content data-hj-suppress>{{ user()?.name }}</span>
</button>

<sb-menu #profileMenu>
  @if (!isSoftLogin()) {
    @if (['Clock time', 'Clock own time'] | permissionCheck: 'me' : 'any') {
      @if (!clockState()?.Timesheet?.active_clock) {
        <a
          sbMenuItem
          variant="none"
          class="bg-success-subtle font-semibold text-success-strong hover:bg-success/15"
          [leadingIcon]="'stopwatch-regular'"
          [routerLink]="clockModalLink"
        >
          {{ 'Clock in' | translate }}
        </a>
      } @else {
        <a
          sbMenuItem
          variant="none"
          class="bg-danger-subtle font-semibold text-danger-strong hover:bg-danger/15"
          [leadingIcon]="'stopwatch-regular'"
          [routerLink]="clockModalLink"
        >
          {{ 'Clock out' | translate }}
        </a>

        @if (showSwitchButton()) {
          <a sbMenuItem [leadingIcon]="'transfer-3-regular'" [routerLink]="clockSwitchModalLink">
            {{ 'Switch shift' | translate }}
          </a>
        }
      }
    }

    <ng-container *subscriptionPlan="planType.BASIC">
      @if (['Approve absentee', 'Approve exchange'] | permissionCheck: 'me' : 'any') {
        <button
          sbMenuItem
          [leadingIcon]="'inbox-regular'"
          [counter]="supervisorOpenRequests()"
          counterTone="attention"
          (triggered)="headerService.supervisorRequestsSidebarOpen$.next(true)"
        >
          {{ 'Approvals' | translate }}
        </button>
      }

      <button
        sbMenuItem
        [leadingIcon]="'send-plane-regular'"
        [counter]="myOpenRequests()"
        counterTone="attention"
        (triggered)="headerService.myRequestsSidebarOpen$.next(true)"
      >
        {{ 'My requests' | translate }}
      </button>

      <sb-menu-separator />
    </ng-container>

    @if (['View own profile', 'Edit own profile'] | permissionCheck: 'me' : 'any') {
      <a sbMenuItem [leadingIcon]="'profile-regular'" routerLink="/my-account/profile">
        {{ 'My profile' | translate }}
      </a>
    }

    <sb-menu-separator />

    <button sbMenuItem class="text-accent" [leadingIcon]="'flask-regular'" (triggered)="openLabsDialog()">
      {{ 'Labs' | translate }}
    </button>

    @if (Features.TMP_BETA_PROGRAM | featureFlag) {
      @if (['Manage account'] | permissionCheck: 'me' : 'any') {
        <a sbMenuItem routerLink="/account/settings" fragment="beta">{{ 'Shiftbase BETA' | translate }}</a>
      }
    }

    <ng-container *subscriptionPlan="planType.BASIC">
      <a
        sbMenuItem
        [leadingIcon]="'sparkles-2-regular'"
        href="https://help.shiftbase.com/release-notes"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "What's new" | translate }}
      </a>
    </ng-container>
  }

  <sb-menu-separator />

  <button
    sbMenuItem
    [leadingIcon]="'palette-regular'"
    [sbMenuTriggerFor]="themeMenu.panel"
    [trailingText]="theme.label() | translate"
  >
    {{ 'Theme' | translate }}
  </button>

  <sb-menu #themeMenu>
    <sb-menu-section
      [ariaLabel]="'Theme' | translate"
      [value]="theme.current()"
      [closeOnSelect]="false"
      (valueChange)="theme.select($event)"
    >
      @for (option of theme.options; track option.value) {
        <button [sbMenuItemRadio]="option.value">{{ option.label | translate }}</button>
      }
    </sb-menu-section>
  </sb-menu>

  <sb-menu-separator />

  <a sbMenuItem [leadingIcon]="'exit-regular'" routerLink="/logout">{{ 'Log out' | translate }}</a>
</sb-menu>
